import { createRequiredContext } from './create-required-context'

/**
 * Style seeds for new text: the book/checkpoint default font and size every new text box starts
 * with, plus the last kerning/tracking/underline/alignment used in the Type panel this session.
 * Changes rarely.
 */
export interface TextDefaults {
  newTextBoxKerning?: number
  newTextBoxTracking?: number
  newTextBoxUnderline?: boolean
  newTextBoxAlignment?: number
  /** Book default point size (`job.defaultFontSize`), else the checkpoint's. */
  defaultFontSize?: number
  /** Book default font family id (`job.defaultFontFamilyId`). */
  defaultFontFamilyId?: number
  /** Checkpoint default font family name, used when `defaultFontFamilyId` is absent. */
  defaultFontName?: string
}

const textDefaults = createRequiredContext<TextDefaults>('TextDefaults')

export const TextDefaultsContext = textDefaults.Context
export const TextDefaultsProvider = textDefaults.Provider
export const useTextDefaults = textDefaults.useRequiredContext
